import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { MspPipesModule } from 'src/app/util/pipes/msp-pipes.module';

export interface searchInputTagsInterface {
	tag: string;
	label: string;
	placeholder_label: string;
	icon: string;
	items?: { name: string; value: string }[];
}

@Component({
	selector: 'cpi-search-input',
	standalone: true,
	imports: [CommonModule, FontAwesomeModule, MspPipesModule],
	templateUrl: './search-input.component.html',
	styleUrl: './search-input.component.css',
})
export class SearchInputComponent implements OnInit, OnChanges {
	@ViewChild('listContainer') listContainer: ElementRef;

	icons = {
		faMagnifyingGlass: faMagnifyingGlass,
	};

	@Input()
	labels = {
		searchPlaceholder: 'Search',
	};

	@Output() getSearch = new EventEmitter<{ tag: searchInputTagsInterface; text: string }>();

	constructor() {
		this.filterList = this.filterList.bind(this);
	}

	ngOnInit(): void {
		this.tags.sort((a, b) => {
			const labelA = this.labels[a.tag] ?? a.tag;
			const labelB = this.labels[b.tag] ?? b.tag;

			if (labelA > labelB) return 1;
			if (labelA < labelB) return -1;
			return 0;
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.openList && changes.openList.currentValue === true && changes.openList.currentValue != changes.openList.previousValue) {
			this.fopenListToLeft();
			this.fopenListToTop();
		}
	}

	@Input()
	lockSearch = false;

	@Input()
	tags: searchInputTagsInterface[] = [];
	tagOnHoverIndex: number;
	selectedSearchTag: searchInputTagsInterface;
	backspaceCount = 0;

	searchPlaceholder = 'lbl_geral_pesquisar';
	searchText = '';

	openList = false;
	openListToLeft = false;
	openListToTop = false;

	handleSearchPlaceHolder(eventType: 'focus' | 'blur') {
		if (this.selectedSearchTag != undefined)
			this.searchPlaceholder = `${this.labels['lbl_geral_buscar_em']}: ${this.labels[this.selectedSearchTag.label] ?? this.selectedSearchTag.label}`;
		else if (eventType == 'focus' && this.tags.length > 0) this.searchPlaceholder = 'lbl_digite_lista_filtros';
		else this.searchPlaceholder = 'lbl_geral_pesquisar';
	}

	canOpenList(): void {
		this.openList = this.searchText.startsWith('/') ? true : false;
	}

	fopenListToLeft(): void {
		if (this.listContainer == undefined) return;
		const rect = this.listContainer.nativeElement.getBoundingClientRect();

		// Check if the right side of the div is outside the viewport
		this.openListToLeft = rect.right > window.innerWidth ? true : false;
	}

	fopenListToTop(): void {
		if (this.listContainer == undefined) return;
		const rect = this.listContainer.nativeElement.getBoundingClientRect();

		// Check if the right side of the div is outside the viewport
		this.openListToTop = rect.bottom > window.innerHeight ? true : false;
	}

	filterList(loopItem: searchInputTagsInterface): boolean {
		const temporarySearchText = this.searchText.replace('/', '');
		if (temporarySearchText == '') return true;
		const tag = loopItem.tag;
		const label = this.labels[loopItem.label] ?? loopItem.label;
		return tag.includes(temporarySearchText) || label.includes(temporarySearchText);
	}

	keyboardEventHandler(KeyboardEvent: KeyboardEvent): void {
		const keys = ['ArrowDown', 'ArrowUp', 'Enter', 'Backspace'];
		if (!keys.includes(KeyboardEvent.key)) return;

		const filteredTags = this.tags.filter((element) => this.filterList(element));

		if (KeyboardEvent.key === 'ArrowDown' && filteredTags?.length > 0 && this.tagOnHoverIndex != filteredTags.length - 1) {
			this.tagOnHoverIndex++;

			return;
		}
		if (KeyboardEvent.key === 'ArrowUp' && filteredTags?.length > 0 && this.tagOnHoverIndex != 0) {
			this.tagOnHoverIndex--;

			return;
		}
		if (KeyboardEvent.key === 'Enter') {
			if (!this.openList || filteredTags.length === 0) {
				this.fsearch();
			}
			if (this.openList && filteredTags.length > 0) {
				this.selectedSearchTag = filteredTags[this.tagOnHoverIndex];
				this.searchText = '';
				this.backspaceCount = 1;
				this.handleSearchPlaceHolder('blur');
				this.canOpenList();
			}

			return;
		}

		if (KeyboardEvent.key === 'Backspace') {
			if (this.searchText === '' && this.selectedSearchTag != undefined && this.backspaceCount > 0) {
				this.searchText = `/${this.selectedSearchTag.tag}`;
				this.selectedSearchTag = undefined;
				this.backspaceCount = 0;
				this.handleSearchPlaceHolder('focus');
				this.canOpenList();
			}
			this.backspaceCount += 1;
		}
	}

	clickTag(): void {
		const filteredTags = this.tags.filter((element) => this.filterList(element));
		this.selectedSearchTag = filteredTags[this.tagOnHoverIndex];
		this.searchText = '';
		this.backspaceCount = 1;
		this.handleSearchPlaceHolder('blur');
		this.canOpenList();
	}

	fsearch(): void {
		if (this.lockSearch) return;
		this.getSearch.emit({ tag: this.selectedSearchTag, text: this.searchText });
	}
}
